import {
  CalendarAttendee,
  CalendarEventDatetime,
  CalendarEventRecurrence,
  CalendarEventReminder,
  CalendarLocation,
  CalendarOrganizer,
} from '@cue/calendars';
import { ResourceAttendee } from './resource-attendee.model';

export enum AssistEventType {
  Identified = 'Identified',
  Anonymous = 'Anonymous',
  Faulty = 'Faulty',
  Limited = 'Limited',
}

export interface AnonymousAssistEvent extends AssistEvent {
  logged: Date;
  assistEventType: AssistEventType.Anonymous;
  reason: string;
  originalEvent: any;
}

export interface FaultyAssistEvent extends AssistEvent {
  logged: Date;
  assistEventType: AssistEventType.Faulty;
  originalEvent: any;
  error: any;
}

export interface LimitedAssistEvent extends AssistEvent {
  assistEventType: AssistEventType.Limited;
  subject?: string;
  end: CalendarEventDatetime;
  start: CalendarEventDatetime;
}

type Status = 'rejected' | 'confirmed' | 'released' | 'need-confirmation' | 'unconfirmed' | 'accepted' | 'tentative';
export type ReservationFilters = {
  filters: {
    showCanceled: boolean;
    state: {
      value: {
        status: Status;
      };
    }[];
  };
  resourceNames: string[];
  attendees: any[];
};

export interface IdentifiedAssistEvent extends AssistEvent {
  assistEventType: AssistEventType.Identified;
  resourceAttendees: ResourceAttendee[];
  // Zakladni eventove veci
  id: string;
  iCalUId: string;
  visibility: 'public' | 'private';
  showAs: { key: string; value: string };
  status: string;
  subject: string;

  // Originalni veci - nechat
  end: CalendarEventDatetime;
  start: CalendarEventDatetime;
  organizer: CalendarOrganizer;
  attendees: CalendarAttendee[];
  locations: CalendarLocation[];
  // .. alespon prozatim
  bodyPreview: string;
  bodyHtml: string;
  seriesMasterId?: string;
  occurrenceId?: string;
  recurrence?: CalendarEventRecurrence | null;
  onlineMeetingProvider: string;
  ownerEventId?: string;
  ownerUserId?: string;
  eventPermissions?: {
    canEditPrivate: boolean;
    canEditPublic: boolean;
    canReadPrivate: boolean;
    canReadPublic: boolean;
    canReadParentEventPublic: boolean;
    canReadParentEventPrivate: boolean;
    canEditParentEventPublic: boolean;
    canEditParentEventPrivate: boolean;
  };

  type: 'singleInstance' | 'occurrence' | 'exception' | 'seriesMaster';
  reminder: CalendarEventReminder;
  // veci k assistovi navic
  isAllDay: boolean;
  finished: boolean;
  cancelled: boolean;
  isOrganizer: boolean;
  afterEnd?: boolean;
  meAttending: boolean;
  showConfirmButton: boolean;
  showChangeButton: boolean;
  showFinishButton: boolean;
  showDeleteButton: boolean;
  // Touchone cal vypocet
  canEditFromColleague: boolean;
  canViewFromColleague: boolean;
}

export interface AssistEvent {
  assistEventType: AssistEventType;
}

export function isIdentifiedAssistEvent(event: any): event is IdentifiedAssistEvent {
  return event.assistEventType == AssistEventType.Identified;
}

export function isAnonymousAssistEvent(event: AssistEvent): event is AnonymousAssistEvent {
  return event.assistEventType == AssistEventType.Anonymous;
}

export function isFaultyAssistEvent(event: AssistEvent): event is FaultyAssistEvent {
  return event.assistEventType == AssistEventType.Faulty;
}
